import LiveDot from "@/components/LiveDot";
import { useLang } from "@/lib/i18n";

/** «عاجل» pill. `active` = the newest breaking story → red dot with pulsing rings.
 *  Otherwise a static pill. `live` variant = black «مباشر» pill with the red pulse. */
export default function BreakingBadge({ active = false, className = "", testId = "breaking-badge" }) {
    const { t } = useLang();
    const badge = (
        <span className={`breaking-badge ${active ? "breaking-badge--active" : ""} ${active ? "" : className}`} data-testid={testId} data-active={active ? "1" : "0"}>
            {active && <LiveDot tone="red" testId={`${testId}-dot`} />}
            <span>{t("breaking")}</span>
        </span>
    );
    // the live «عاجل» badge carries the approved slow teal→petrol beam; static ones stay plain
    return active ? <span className={`beam-ring beam-ring--slow beam-ring--badge rounded-[5px] ${className}`}>{badge}</span> : badge;
}

export function LiveBadge({ className = "", testId = "live-badge" }) {
    const { t } = useLang();
    return (
        <span className={`beam-ring beam-ring--slow beam-ring--badge rounded-[5px] ${className}`}>
            <span className="live-badge" data-testid={testId}>
                <LiveDot tone="red" testId={`${testId}-dot`} />
                <span>{t("live")}</span>
            </span>
        </span>
    );
}
